<template>
  <div>
    <PageAllow
      controller="OrderMaterialAnalyze"
      action="orderCategoryFreightView"
    />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color pa-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ $t("orderCategoryFreight.DetailFields.detail") }}
            </v-card-title>
          </v-expansion-panel-header>
          <v-divider />
          <v-expansion-panel-content>
            <v-row no-gutters class="mt-4 table-style">
              <v-col cols="12" md="6">
                <v-card class="pa-2" outlined tile>
                  <span class="secondary--text text-end">
                    {{ $t("orderCategoryFreight.DetailFields.order_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>{{ order.order_code }} </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card class="pa-2" outlined tile>
                  <span class="secondary--text text-end">
                    {{ $t("orderCategoryFreight.DetailFields.logistics_fee")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span
                    >{{ $t("Global.money")
                    }}{{ order.express_price | formatMoney }}
                  </span>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-data-table
        :headers="detailsHeaders"
        :items="order.order_category_express_fee"
        multi-sort
        disable-pagination
        hide-default-footer
        :no-data-text="$t('orderCategoryFreight.DetailFields.DetailNoData')"
        class="elevation-2 px-4 mt-4"
      >
        <template v-slot:top>
          <v-toolbar flat class="transparent-background-color">
            <v-toolbar-title class="ms-n2">
              {{ $t("orderCategoryFreight.DetailFields.details") }}
            </v-toolbar-title>
            <v-spacer />
            <span class="secondary--text text-subtitle-2 font-weight-bold">
              {{ $t("orderCategoryFreight.DetailFields.category_express_total")
              }}{{ $t("Global.colon") }}
            </span>
            <span class="accent--text text-subtitle-2 font-weight-bold">
              {{ $t("Global.money")
              }}{{ order.category_express_total | formatMoney }}
            </span>
          </v-toolbar>
          <v-divider />
        </template>
        <template v-slot:item.express_price="{ item }">
          {{ $t("Global.money") }}{{ item.express_price | formatMoney }}
        </template>
      </v-data-table>
    </v-sheet>
  </div>
</template>
<script>
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import i18n from "@/i18n";
import OrderMaterialAnalyze from "@/api/order-material-analyze";
export default {
  components: {
    PageAllow,
    Breadcrumbs,
  },
  data: () => ({
    panels: [0],
    order: {},
  }),
  mounted() {
    this.getOrderCategoryFreightFromAPI();
  },
  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.orderCategoryFreight"),
          disabled: false,
          href: "/order-category-freight",
        },
        {
          text: i18n.t("orderCategoryFreight.detail"),
          disabled: true,
        },
      ];
    },
    detailsHeaders: () => [
      {
        text: i18n.t("orderCategoryFreight.DetailFields.category_name"),
        align: "start",
        value: "category_name",
      },
      {
        text: i18n.t("orderCategoryFreight.DetailFields.express_price"),
        align: "start",
        value: "express_price",
      },
    ],
  },
  methods: {
    getOrderCategoryFreightFromAPI() {
      OrderMaterialAnalyze.fetchDetail(this.$route.params.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.order = response.data.order;
          }
        }.bind(this)
      );
    },
  },
};
</script>